import { Button, Tooltip } from 'antd'
import { isValidElement } from 'react'
import { MdDeleteOutline, MdOutlineDescription } from 'react-icons/md'

import { GetResourceTask } from '@/Core/Tasks/Resources/GetResourceTask'
import { classNames } from '@/Ship/Helpers/classNames'

import type { Favorite } from '@/Ship/Stores/FavoritesManager'
import type { KeyboardEvent, MouseEvent } from 'react'

import styles from './Favorites.module.css'

interface FavoritesListItemProps {
    item: Favorite
    // eslint-disable-next-line no-unused-vars -- ім'я параметра в типі функції
    onOpen: (item: Favorite) => void
    // eslint-disable-next-line no-unused-vars -- ім'я параметра в типі функції
    onRemove: (item: Favorite) => void
}

/**
 * Один запис обраного: значок розділу, назва, під нею коментар, кошик.
 *
 * Рядок цілком — посилання на картку. Кошик праворуч видаляє позначку — текст
 * і дія легасі («Видалити», `FavoriteList.jsx:151-157`), а не зірочка PD.
 */
export const FavoritesListItem = ({ item, onOpen, onRemove }: FavoritesListItemProps) => {
    // ⚠️ Іконка розділу — уже готовий елемент (`<MdOutlineChecklist />`), а не
    // компонент: малювати її як `<Icon />` означало б падіння всього списку
    const icon: unknown = GetResourceTask(item.entityCode)?.['pageConfig']?.icon

    const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            onOpen(item)
        }
    }

    const remove = (event: MouseEvent) => {
        event.stopPropagation()
        onRemove(item)
    }

    return (
        <div
            role="button"
            tabIndex={0}
            className={classNames(styles['item'])}
            onClick={() => onOpen(item)}
            onKeyDown={onKeyDown}
        >
            <span className={classNames(styles['icon'])}>{isValidElement(icon) ? icon : <MdOutlineDescription />}</span>

            <span className={classNames(styles['text'])}>
                <span className={classNames(styles['title'])} title={item.title}>
                    {item.title}
                </span>
                {item.comment && (
                    <span className={classNames(styles['comment'])} title={item.comment}>
                        {item.comment}
                    </span>
                )}
            </span>

            <Tooltip title="Видалити" placement="left">
                <Button
                    type="text"
                    shape="circle"
                    aria-label="Видалити"
                    icon={<MdDeleteOutline style={{ fontSize: 20, color: 'var(--ant-color-error)' }} />}
                    onClick={remove}
                />
            </Tooltip>
        </div>
    )
}
